<div class="set-filter">
  <div class="set-filter-actions">
    <button type="button" (click)="selectAll()">Select all</button>
    <button type="button" (click)="clear()">Clear</button>
  </div>
  <div class="set-filter-list">
    @for (option of options(); track option.value) {
      <label class="set-filter-item">
        <input type="checkbox" [checked]="selected().has(option.value)" (change)="toggle(option.value)"/>
        <span>{{ option.label }}</span>
      </label>
    }
  </div>
</div>
